<div class="query-builder scrollable">
  <div class="spinner-container" *ngIf="isLoading">
    <p-progress-spinner></p-progress-spinner>
  </div>
  <div class="section-table-container lookup-tbl mandatory-param" *ngIf="queryParamMapping?.length > 0">
    <div>
      <div class="section-table-container mandatory-param-table">
        <div class="d-flex flex-column">
          <p-table
            [value]="queryParamMapping"
            class="fil-map-table"
            [showGridlines]="true"
            [style]="{ width: '100%' }"
            [scrollable]="true"
          >
            <ng-template #header>
              <tr>
                <th>
                  <span class="required">{{ 'MANDATORY_PARAMETERS' | translate }}</span>
                </th>
                <th>{{ 'TYPE' | translate }}</th>
                <th>{{ 'MAPPING' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template #body let-data let-rowIndex="rowIndex">
              <tr>
                <td>
                  <span class="lbl-class">{{ data.listField.name }}</span>
                </td>
                <td>
                  <div class="d-flex align-items-center param-map-type form-group prop-elems p-0">
                    <p-select
                      [(ngModel)]="data.type"
                      [disabled]="disableField"
                      [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                      [options]="
                        data?.listField?.f_type === 'Date' || data?.listField?.f_type === 'DateTime'
                          ? typeOptionsForDate
                          : typeOptions
                      "
                      optionLabel="name"
                      (onChange)="onTypeValueChange($event, rowIndex)"
                      appendTo="body"
                      [emptyMessage]="'No records found'"
                      placeholder="Select"
                      class="w-100"
                    >
                    </p-select>
                  </div>
                </td>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="form-group prop-elems w-100">
                      <span *ngIf="data.type?.value === 'pageVariable'">
                        <div class="field-container" [class.warning-border]="isFieldMismatch(data)" [class.errors-border]="isFieldNoLonger(data)">
                          <p-autocomplete
                            [(ngModel)]="data.detailField"
                            [disabled]="!data.listField"
                            [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                            [suggestions]="pageVariables"
                            (onSelect)="onPageVariablesSel($event, data)"
                            trim="blur"
                            appendTo="body"
                            [showEmptyMessage]="true"
                            (completeMethod)="showPageVariables($event, data.detailField, data.listField)"
                            [dropdown]="true"
                            [forceSelection]="true"
                            field="name"
                            panelStyleClass="pv-autocomplete"
                            placeholder="Select"
                            tooltipStyleClass="label-tooltip custom-tooltip-properties"
                            pTooltip="{{ data.detailField ? data.detailField.name : null }}"
                          >
                            <ng-template let-field pTemplate="item">
                              <div class="field-item" [pTooltip]="field.name" tooltipPosition="top">
                                <span>{{ field.name }}</span>
                              </div>
                            </ng-template>
                          </p-autocomplete>
                          <div class="warning-container">
                            <i *ngIf="isFieldMismatch(data)"
                              class="pi pi-exclamation-triangle warning-icon"
                              tabindex="0"
                              (click)="showPopup = !showPopup"
                              (keyup.enter)="showPopup = !showPopup"
                              (keyup.space)="showPopup = !showPopup">
                            </i>
                            <i *ngIf="isFieldNoLonger(data)"
                              class="pi pi-exclamation-circle errors-icon"
                              tabindex="0"
                              (click)="showPopup = !showPopup"
                              (keyup.enter)="showPopup = !showPopup"
                              (keyup.space)="showPopup = !showPopup">
                            </i>
                          </div>
                          <div *ngIf="showPopup" class="popup-container">
                            <div *ngIf="isFieldMismatch(data)" class="warning-popup">
                              <div class="popup-header">
                                <i class="pi pi-exclamation-triangle"></i>
                                Warning
                              </div>
                              <div class="popup-content">
                                {{ 'FLD_MISMATCH' | translate }}
                              </div>
                              <button class="close-btn" (click)="showPopup = false">×</button>
                            </div>
                            <div *ngIf="isFieldNoLonger(data)" class="warning-popup-errors">
                              <div class="popup-header-errors">
                                <i class="pi pi-exclamation-circle"></i>
                                Error
                              </div>
                              <div class="popup-content-errors">
                                {{ 'FLD_NO_LONGER' | translate }}
                              </div>
                              <button class="close-btn-errors" (click)="showPopup = false">×</button>
                            </div>
                          </div>
                        </div>
                      </span>
                      <span *ngIf="data.type?.value === 'value' || !data.type">
                        <ng-container [ngSwitch]="data.listField.f_type">
                          <ng-template
                            [ngSwitchCase]="
                              ['String', 'Email', 'Color'].includes(data.listField.f_type)
                                ? data.listField.f_type
                                : null
                            "
                          >
                            <input
                              [name]="element.name"
                              [attr.id]="element.name"
                              type="text"
                              class="form-control form-control-sm"
                              [(ngModel)]="data.staticValue"
                              (focusout)="onValueChange($event, data.listField.f_type)"
                              [disabled]="disableField"
                            />
                          </ng-template>
                          <ng-template
                            [ngSwitchCase]="
                              ['Auto-number', 'Number'].includes(data.listField.f_type) ? data.listField.f_type : null
                            "
                          >
                            <div *ngIf="data?.range">
                              <div class="d-flex mb-1 align-items-center">
                                <span class="lbl-class">{{ 'FROM' | translate }}</span>
                                <p-inputNumber
                                  [(ngModel)]="data.staticValue[0]"
                                  class="form-control form-control-sm"
                                  [attr.id]="element.name"
                                  (onBlur)="onValueChange($event)"
                                  maxlength="16"
                                  [disabled]="disableField"
                                ></p-inputNumber>
                              </div>
                              <div class="d-flex align-items-center">
                                <span class="lbl-class">{{ 'TO' | translate }}</span>
                                <p-inputNumber
                                  [(ngModel)]="data.staticValue[1]"
                                  class="form-control form-control-sm"
                                  [attr.id]="element.name"
                                  (onBlur)="onValueChange($event)"
                                  maxlength="16"
                                  [disabled]="disableField"
                                ></p-inputNumber>
                              </div>
                            </div>
                            <div *ngIf="!data?.range">
                              <p-inputNumber
                                [(ngModel)]="data.staticValue"
                                class="form-control form-control-sm"
                                [attr.id]="element.name"
                                (onBlur)="onValueChange($event)"
                                maxlength="16"
                                [disabled]="disableField"
                              ></p-inputNumber>
                            </div>
                          </ng-template>
                          <ng-template
                            [ngSwitchCase]="
                              ['Currency', 'Double'].includes(data.listField.f_type) ? data.listField.f_type : null
                            "
                          >
                            <div *ngIf="data?.range">
                              <div class="d-flex mb-1 align-items-center">
                                <span class="lbl-class">{{ 'FROM' | translate }}</span>
                                <p-inputNumber
                                  [(ngModel)]="data.staticValue[0]"
                                  class="form-control form-control-sm"
                                  [attr.id]="element.name"
                                  (onBlur)="onValueChange($event)"
                                  maxlength="16"
                                  [disabled]="disableField"
                                ></p-inputNumber>
                              </div>
                              <div class="d-flex align-items-center">
                                <span class="lbl-class">{{ 'TO' | translate }}</span>
                                <p-inputNumber
                                  [(ngModel)]="data.staticValue[1]"
                                  class="form-control form-control-sm"
                                  [attr.id]="element.name"
                                  (onBlur)="onValueChange($event)"
                                  maxlength="16"
                                  [disabled]="disableField"
                                ></p-inputNumber>
                              </div>
                            </div>
                            <div *ngIf="!data?.range">
                              <p-inputNumber
                                [(ngModel)]="data.staticValue"
                                class="form-control form-control-sm"
                                [disabled]="disableField"
                                mode="decimal"
                                [attr.id]="element.name"
                                (onBlur)="onValueChange($event)"
                                maxlength="16"
                                [minFractionDigits]="data.listField.f_minFrac"
                                [maxFractionDigits]="data.listField.f_maxFrac"
                              ></p-inputNumber>
                            </div>
                          </ng-template>
                          <ng-template
                            [ngSwitchCase]="
                              ['Checkbox', 'Boolean'].includes(data.listField.f_type) ? data.listField.f_type : null
                            "
                          >
                            <p-checkbox
                              [binary]="true"
                              [inputId]="element.name"
                              [name]="element.name"
                              [disabled]="disableField"
                              [attr.id]="element.name"
                              styleClass="mt-2"
                              [(ngModel)]="data.staticValue"
                              (onChange)="onValueChange($event)"
                            ></p-checkbox>
                          </ng-template>
                          <ng-template [ngSwitchCase]="'Text'">
                            <textarea
                              pTextarea
                              [(ngModel)]="data.staticValue"
                              [attr.id]="element.name"
                              class="form-control form-control-sm"
                              [rows]="1"
                              autoResize="autoResize"
                              (input)="onValueChange($event)"
                              [disabled]="disableField"
                            ></textarea>
                          </ng-template>
                          <ng-template
                            [ngSwitchCase]="
                              ['Dropdown', 'Radio'].includes(data.listField.f_type) ? data.listField.f_type : null
                            "
                          >
                            <div *ngIf="data?.range">
                              <p-multiselect
                                resetFilterOnHide="true"
                                [options]="data.dynamicOptions"
                                optionLabel="label"
                                optionValue="value"
                                [(ngModel)]="data.staticValue"
                                appendTo="body"
                                (onPanelHide)="onValueChange($event)"
                                [disabled]="disableField"
                              >
                              </p-multiselect>
                            </div>
                            <div *ngIf="!data?.range">
                              <vb-dynamic-dropdown
                                [options]="data.dynamicOptions"
                                [element]="element"
                                [(ngModel)]="data.staticValue"
                                [disableField]="disableField"
                                [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                                (valChanges)="onValueChange($event)"
                              >
                              </vb-dynamic-dropdown>
                            </div>
                          </ng-template>
                          <ng-template [ngSwitchCase]="'Date'">
                            <div *ngIf="data?.range">
                              <div class="d-flex mb-1 align-items-center">
                                <span class="lbl-class">{{ 'FROM' | translate }}</span>
                                <p-datepicker
                                  [(ngModel)]="data.staticValue[0]"
                                  dateFormat="dd/mm/yy"
                                  [disabled]="disableField"
                                  [appendTo]="'body'"
                                  (onSelect)="onValueChange($event)"
                                >
                                </p-datepicker>
                              </div>
                              <div class="d-flex mb-1 align-items-center">
                                <span class="lbl-class">{{ 'TO' | translate }}</span>
                                <p-datepicker
                                  [(ngModel)]="data.staticValue[1]"
                                  dateFormat="dd/mm/yy"
                                  [disabled]="disableField"
                                  [appendTo]="'body'"
                                  (onSelect)="onValueChange($event)"
                                >
                                </p-datepicker>
                              </div>
                            </div>
                            <div *ngIf="!data?.range">
                              <p-select
                                [options]="dateOptions"
                                [(ngModel)]="data.staticValue"
                                placeholder="Select"
                                appendTo="body"
                                [disabled]="disableField"
                                [showClear]="true"
                                (onChange)="onValueChange($event)"
                                optionLabel="label"
                                optionValue="value"
                              >
                              </p-select>
                            </div>
                          </ng-template>
                          <ng-template [ngSwitchCase]="'DateTime'">
                            <div *ngIf="data?.range">
                              <div class="d-flex mb-1 align-items-center">
                                <span class="lbl-class">{{ 'FROM' | translate }}</span>
                                <p-datepicker
                                  [(ngModel)]="data.staticValue[0]"
                                  dateFormat="dd/mm/yy"
                                  [disabled]="disableField"
                                  [showTime]="true"
                                  [appendTo]="'body'"
                                  [showSeconds]="true"
                                  (onSelect)="onValueChange($event)"
                                ></p-datepicker>
                              </div>
                              <div class="d-flex align-items-center">
                                <span class="lbl-class">{{ 'TO' | translate }}</span>
                                <p-datepicker
                                  [(ngModel)]="data.staticValue[1]"
                                  dateFormat="dd/mm/yy"
                                  [disabled]="disableField"
                                  [showTime]="true"
                                  [appendTo]="'body'"
                                  [showSeconds]="true"
                                  (onSelect)="onValueChange($event)"
                                ></p-datepicker>
                              </div>
                            </div>
                            <div *ngIf="!data?.range">
                              <p-select
                                [options]="dateOptions"
                                [(ngModel)]="data.staticValue"
                                placeholder="Select"
                                appendTo="body"
                                [disabled]="disableField"
                                [showClear]="true"
                                (onChange)="onValueChange($event)"
                                optionLabel="label"
                                optionValue="value"
                              >
                              </p-select>
                            </div>
                          </ng-template>
                          <ng-template [ngSwitchCase]="'Yes No'">
                            <p-select
                              [options]="ynOptions"
                              [(ngModel)]="data.staticValue"
                              optionLabel="name"
                              placeholder="Select"
                              [disabled]="disableField"
                              optionValue="value"
                              (onChange)="onValueChange($event)"
                              [appendTo]="'body'"
                            >
                            </p-select>
                          </ng-template>
                          <ng-template [ngSwitchCase]="'URL'">
                            <input
                              [name]="element.name"
                              [attr.id]="element.name"
                              type="url"
                              class="form-control form-control-sm"
                              [disabled]="disableField"
                              [(ngModel)]="data.staticValue"
                              (focusout)="onValueChange($event)"
                            />
                          </ng-template>
                        </ng-container>
                      </span>
                      <span *ngIf="data?.type?.value === 'plusDays' || data?.type?.value === 'minusDays'">
                        <p-inputNumber
                          [(ngModel)]="data.detailField"
                          class="form-control form-control-sm"
                          [attr.id]="element.name"
                          [min]="1"
                          (onBlur)="onValueChange($event)"
                          maxlength="6"
                          [useGrouping]="false"
                          [disabled]="disableField"
                        ></p-inputNumber>
                      </span>
                    </div>
                  </div>
                </td>
                <!-- <td class="text-center">
                                    <div class="page-variables-actions" *ngIf="!disableField">
                                        <svg-icon (click)="openOption(data)" src="assets\images\svg\edit.svg"
                                            class="icon-plus cursor-pointer mr-1" alt="edit" aria-hidden="true"
                                            showDelay="100" hideDelay="100" pTooltip="Edit"
                                            tooltipPosition="top"></svg-icon>
                                    </div>
                                </td> -->
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr class="no-records">
                <td colspan="3" class="text-center w-100">
                  {{ 'NO_RECORDS_FOUND' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
